import { Common, ApiBind } from './common.model';

export class ExchangeRate extends Common {
  @ApiBind({ column: 'currency' })
  currency: string;

  @ApiBind({ column: 'current_yen' })
  currentYen: number;

  @ApiBind({ column: 'current_rate' })
  currentRate: number;

  @ApiBind({ column: 'next_yen' })
  nextYen: number;

  @ApiBind({ column: 'next_rate' })
  nextRate: number;

  @ApiBind({ column: 'applied_at' })
  appliedAt: string;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;
}
